import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useVendor } from '../contexts/VendorContext';
import LoadingSpinner from './LoadingSpinner';

export default function VendorProtectedRoute({ children }) {
  const { vendor, loading, isAuthenticated } = useVendor();
  const location = useLocation();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <LoadingSpinner size="lg" />
          <p className="mt-4 text-gray-600">Loading vendor dashboard...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !vendor) {
    return <Navigate to="/vendor/login" state={{ from: location }} replace />;
  }

  return children;
}
